import { render, staticRenderFns } from "./BaseInfiniteScroll.vue?vue&type=template&id=dbc829e6&"
import script from "./BaseInfiniteScroll.vue?vue&type=script&lang=js&"
export * from "./BaseInfiniteScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports